import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from './Form';
import * as API from '../core/api';
import { catchFormErrors } from '../utils/form-errors';
import { requestDataIfNeeded as requestProjectMemos } from './duck';
import { requestDataIfNeeded as requestGoalsMemos } from '../goals/memos/duck';
import Project from '../projects/class';

class Create extends React.Component {
  handleSubmit = ({ content }, dispatch, { project, goal }) => {
    const { requestProjectMemos, requestGoalsMemos, onSuccess } = this.props;
    return (
      API.post('memos', {
        project: project && project._id,
        goal: goal && goal._id,
        content,
      })
        // Refresh the memos
        .then(() => project && requestProjectMemos({ project: project._id }))
        .then(() => goal && requestGoalsMemos({ user: goal.user }))
        .then(onSuccess)
        .catch(catchFormErrors)
    );
  };

  render() {
    const { t, project, goal, type } = this.props;

    return (
      <Form
        form="project-memo-create"
        project={project}
        goal={goal}
        okButtonText={t('project.memo.submit')}
        onSubmit={this.handleSubmit}
        type={type}
      />
    );
  }
}

Create.defaultProps = {
  type: 'PROJECT',
};

Create.propTypes = {
  project: PropTypes.instanceOf(Project),
  goal: PropTypes.object,
  type: PropTypes.oneOf(['PROJECT', 'GOAL']),
};

const mapDispatchToProps = {
  requestProjectMemos,
  requestGoalsMemos,
};

export default connect(
  null,
  mapDispatchToProps
)(translate()(Create));



// WEBPACK FOOTER //
// ./src/memos/Create.js